export enum OfflineBookDownloadStatus {
    Downloaded,
    InProgress,
    NotDownloaded,
    UpdateAvailable,
}
